import { render, staticRenderFns } from "./productionReport.vue?vue&type=template&id=0c5a2c96&scoped=true"
import script from "./productionReport.vue?vue&type=script&lang=js"
export * from "./productionReport.vue?vue&type=script&lang=js"
import style0 from "./productionReport.vue?vue&type=style&index=0&id=0c5a2c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a2c96",
  null
  
)

export default component.exports